export default __webpack_public_path__ + "static/media/hero.78a9965c.png";